import React, { useState } from "react";
import {
  Grid,
  IconButton,
  Icons,
  Menu,
  PopupPosition,
  RelativePopupWrapper,
} from "@pushpress/shared-components";
import styles from "./InfoModalHeader.module.scss";

export type ContextMenuActions = {
  onDuplicate?: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
};

type InfoModalHeaderProps = {
  onClose?: VoidFunction;
};

const InfoModalHeader = ({
  onClose,
  onDuplicate,
  onEdit,
  onDelete,
}: InfoModalHeaderProps & ContextMenuActions) => {
  const [contextMenuVisible, setContextMenuVisible] = useState(false);

  return (
    <Grid
      container
      justifyContent="flex-end"
      spacing={3}
      className={styles.root}
    >
      <>
        {onEdit ||
          onDuplicate ||
          (onDelete && (
            <Grid item>
              <RelativePopupWrapper
                popupComponent={
                  <Menu>
                    {onEdit && <Menu.Item label="Edit" action={onEdit} />}
                    {onDuplicate && (
                      <Menu.Item label="Duplicate" action={onDuplicate} />
                    )}
                    {onDelete && <Menu.Item label="Delete" action={onDelete} />}
                  </Menu>
                }
                popupVisible={contextMenuVisible}
                popupPosition={PopupPosition.Bottom_Left_Outside}
                setPopupVisibility={setContextMenuVisible}
                dismissOnOutsideClick
              >
                <IconButton
                  icon={Icons.Kebabs}
                  onClick={() => setContextMenuVisible((prev) => !prev)}
                  size={24}
                />
              </RelativePopupWrapper>
            </Grid>
          ))}

        <Grid item>
          <IconButton icon={Icons.X} onClick={onClose} size={24} />
        </Grid>
      </>
    </Grid>
  );
};

export default InfoModalHeader;
